import { render, staticRenderFns } from "./AutomationWizardFieldDate.vue?vue&type=template&id=b504b0e6&scoped=true&"
import script from "./AutomationWizardFieldDate.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardFieldDate.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardFieldDate.vue?vue&type=style&index=0&id=b504b0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b504b0e6",
  null
  
)

export default component.exports